<template>
  <div class="flex flex-1 flex-row items-center gap-2 truncate p-3">
    <FontAwesomeIcon
      v-if="displaySubTaskButton && dossier.tasks && dossier.tasks.length"
      :icon="['fal', 'chevron-right']"
      size="sm"
      class="flex-shrink-0 cursor-pointer"
      @click="$emit('toggle-tasks')"
    />
    <RouterLink
      class="flex flex-1 place-content-between gap-1 truncate"
      :to="dossier[column.field]?.router"
    >
      <span class="inline-block truncate">
        {{ dossier[column.field].label }}
      </span>
      <span v-if="dossier?.infection" class="shrink-0">
        <FontAwesomeIcon
          class="text-theme-danger"
          :icon="['fas', 'virus-covid']"
          size="lg"
        />
      </span>
      <span v-if="!dossier.complete" class="shrink-0">
        <FontAwesomeIcon
          class="text-theme-danger"
          :icon="['fas', 'triangle-exclamation']"
          size="lg"
        />
      </span>
    </RouterLink>
  </div>
</template>
<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

export default {
  name: 'DossierTitleElement',
  components: { FontAwesomeIcon },
  props: {
    column: { type: Object, required: true },
    dossier: { type: Object, required: true },
    displaySubTaskButton: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: ['toggle-tasks'],
  mounted() {
    // console.log('dossier', this.dossier)
    // console.log('column', this.column)
  }
}
</script>
